import React from "react";
import { Link } from "react-router-dom";
import "../style/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="legal-page">
      {/* PAGE HEADER */}
      <div className="legal-header">
        <h1>Terms and Conditions</h1>
        <p>
          <Link to="/">Home</Link> / <span>Terms and Conditions</span>
        </p>
      </div>

      {/* PAGE CONTENT */}
      <div className="legal-content">

        <h2>Introduction</h2>
        <p>
          <strong>PFA Logistics Pvt. Ltd.</strong> ("Website" or "www.pfalogistics.com")
          is owned and operated by PFA Logistics Pvt. Ltd. ("PFA Logistics", "we",
          "us", or "our"). By accessing or using this website, you agree to be bound
          by these Terms and Conditions, which may be updated from time to time
          without prior notice.
        </p>

        <h2>Ownership of Rights</h2>
        <p>
          Any use of this website or its content, including copying, storing,
          modifying, reproducing, or distributing, other than for personal,
          non-commercial use, is strictly prohibited without prior written
          permission from <strong>PFA Logistics Pvt. Ltd.</strong>
        </p>

        <p>
          All text, images, graphics, logos, and other content displayed on this
          website are protected by copyright and intellectual property laws and
          are owned or licensed by PFA Logistics Pvt. Ltd.
        </p>

        <h2>Disclaimer</h2>
        <p>
          All information, services, images, and content on this website are
          provided “as is” without any warranties, express or implied, including
          merchantability or fitness for a particular purpose.
        </p>

        <p>
          Use of this website is at your own risk. The information provided here
          is for general reference only and does not constitute professional or
          legal advice.
        </p>

        <p>
          PFA Logistics Pvt. Ltd. shall not be liable for any direct, indirect,
          incidental, or consequential damages arising from the use of this
          website.
        </p>

        <h2>Website Security</h2>
        <p>
          PFA Logistics Pvt. Ltd. takes reasonable steps to maintain the security
          of this website; however, we do not guarantee that the website will be
          free from viruses or harmful components. Users are advised to take
          necessary precautions.
        </p>

        <h2>Governing Law</h2>
        <p>
          These Terms and Conditions shall be governed by the laws of India.
          Courts located in Delhi shall have exclusive jurisdiction.
        </p>

        <h2>Communication</h2>
        <p>
          By using this website, you consent to receive communications from us
          electronically via email, SMS, WhatsApp, or website notifications
          related to our services.
        </p>

        <h2>User Feedback & Content</h2>
        <p>
          Any comments, feedback, suggestions, or content submitted by users
          shall become the property of <strong>PFA Logistics Pvt. Ltd.</strong>.
          We reserve the right to use, reproduce, modify, or distribute such
          content without any obligation or compensation.
        </p>

        <p>
          Users agree not to submit unlawful, abusive, defamatory, or harmful
          content.
        </p>

        <h2>Privacy Policy</h2>
        <p>
          Customer information is used only for service communication, delivery
          updates, and improving our services.
        </p>

        <p>
          For more details, please review our{" "}
          <Link to="/privacy">Privacy Policy</Link> or contact us at{" "}
          <a href="mailto:info@zedexsoftware.com">
            info@zedexsoftware.com
          </a>.
        </p>

      </div>
    </div>
  );
};

export default TermsConditions;
